/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyAsiFilter } from '../../models/my-asi-filter';

export interface GetMyAsiFilter$Params {
  activity: string;
}

export function getMyAsiFilter(http: HttpClient, rootUrl: string, params: GetMyAsiFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<MyAsiFilter>> {
  const rb = new RequestBuilder(rootUrl, getMyAsiFilter.PATH, 'get');
  if (params) {
    rb.path('activity', params.activity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MyAsiFilter>;
    })
  );
}

getMyAsiFilter.PATH = '/auth/myasi-filter/{activity}';
